'use strict';

(function () {
  'use strict';

  angular.module('msUtility').filter('translateInterpolate', ['$parse', '$translate', translateFilterFactory]);

  function translateFilterFactory($parse, $translate) {

    var translateFilter = function translateFilter(translationId, extraParam) {
      if (angular.isString(extraParam)) {
        return extraParam;
      }
      if (angular.isObject(extraParam)) {
        return $translate.instant(translationId, extraParam);
      }
      return $translate.instant(translationId);
    };
    translateFilter.$stateful = true;
    return translateFilter;
  }
})();